import { AV_PERMISSION_STATUS_INIT } from 'Store/app/constants';

import type { AppState } from './types';

const initialState: AppState = {
  avPermissionStatus: AV_PERMISSION_STATUS_INIT,
  appSource: null,
  activeTab: true,
  branding: null,
  deeplinkSource: '',
  deviceFlaggedForDobViolation: false,
  dobViolationDaysLeft: 0,
  is3dsComplete: false,
  lifecycles: {},
  offline: false,
  preAuthLeversLoaded: false,
  profileLoaded: false,
  authAttributionData: {
    attributionId: '',
    attributionSource: '',
  },
};

export default initialState;
